import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import SprintItemsIndex from '../../../components/Admin/Sprints/SprintItemsIndex';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const SprintItemsIndexContainer = (props) => (
  <ApolloProvider client={client}>
    <SprintItemsIndex {...props} />
  </ApolloProvider>
);

export default SprintItemsIndexContainer;


